import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getStudent(id) {
  const response = await fetch(`${baseUrl}students/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getStudents() {
  const response = await fetch(`${baseUrl}students`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getStudentsForClient(clientId) {
  const response = await fetch(`${baseUrl}students?clientId=${clientId}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveStudent(student) {
  const response = await fetch(`${baseUrl}students/${student.id || ""}`, {
    method: student.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(student),
  });
  return handleResponse(response);
}

export default {
  getStudent,
  getStudentsForClient,
  getStudents,
  saveStudent,
};
